import React from 'react';
import { Facilities } from '@lt/components';
import EmptyFacilities from './EmptyFacilities';
import type { FacilitiesContainerProps } from './types';

const FacilitiesContainer = ({
  isMobile,
  attractions,
  kids,
  room,
  territory,
}: FacilitiesContainerProps) =>
  room || attractions || kids || territory ? (
    <Facilities
      isMobile={isMobile}
      attractions={attractions}
      kids={kids}
      room={room}
      territory={territory}
      showBestItemBackground={!isMobile}
      showItemBackground={!isMobile}
    />
  ) : (
    <EmptyFacilities isMobile={isMobile} />
  );

export default FacilitiesContainer;
